/** Where the app sends a user after login when no redirect path was stored. */
export const POST_LOGIN_REDIRECT_PATH = "/dashboard";

/**
 * When true, sidebar/header logos invert in light mode (for marks designed on
 * dark backgrounds). Templates set this via `shouldInvertLogo` in the manifest.
 */
export const SHOULD_INVERT_LOGO = false;
